import Parse from 'parse'

class ContactApi {
  /**
   * Send a contact form submission to the backend via Parse Cloud Function
   * @param {Object} params - The contact form data
   * @param {string} params.name - The sender's name
   * @param {string} params.email - The sender's email
   * @param {string} params.message - The message content
   * @returns {Promise<any>} - The server response
   */
  async sendContactForm(params: { name: string; email: string; message: string }): Promise<any> {
    return Parse.Cloud.run('Misc_contactUs', params)
  }
}

export default new ContactApi()
